import { _ as _createClass, a as _classCallCheck } from './classCallCheck-E4khD9xn.js';
import { r as removeElement, m as merge, z as getComponentFromVNode, A as copyAppContext, _ as _defineProperty } from './helpers-O9h6_ICO.js';
import { resolveComponent, resolveDirective, openBlock, createBlock, Transition, withCtx, withDirectives, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, createVNode, renderSlot, Fragment, mergeProps, withKeys, vModelDynamic, createTextVNode, createApp, h } from 'vue';
import { t as trapFocus } from './trapFocus-IMs77O3T.js';
import { s as script$1 } from './Icon-fJqkx1gN.js';
import { s as script$3 } from './Modal-au57IFsU.js';
import { s as script$2 } from './Button-KVoJ7jHH.js';
import { c as config } from './config-nHWiBviw.js';
import { a as registerComponent, r as registerComponentProgrammatic } from './plugins-C7548x21.js';
import './typeof-Z4rCTFCZ.js';

var script = {
    name: 'BDialog',
    components: {
        [script$1.name]: script$1,
        [script$2.name]: script$2
    },
    directives: {
        trapFocus
    },
    extends: script$3,
    props: {
        title: String,
        message: [String, Array],
        icon: String,
        iconPack: String,
        hasIcon: Boolean,
        type: {
            type: String,
            default: 'is-primary'
        },
        size: String,
        confirmText: {
            type: String,
            default: () => {
                return config.defaultDialogConfirmText
                    ? config.defaultDialogConfirmText
                    : 'OK'
            }
        },
        cancelText: {
            type: String,
            default: () => {
                return config.defaultDialogCancelText
                    ? config.defaultDialogCancelText
                    : 'Cancel'
            }
        },
        hasInput: Boolean, // Used internally to know if it's prompt
        inputAttrs: {
            type: Object,
            default: () => ({})
        },
        confirmCallback: {
            type: Function,
            default: () => {}
        },
        closeOnConfirm: {
            type: Boolean,
            default: true
        },
        container: {
            type: String,
            default: () => {
                return config.defaultContainerElement
            }
        },
        focusOn: {
            type: String,
            default: 'confirm'
        },
        trapFocus: {
            type: Boolean,
            default: () => {
                return config.defaultTrapFocus
            }
        },
        ariaRole: {
            type: String,
            validator: (value) => {
                return [
                    'dialog',
                    'alertdialog'
                ].indexOf(value) >= 0
            }
        },
        ariaModal: Boolean
    },
    emits: ['confirm'],
    data() {
        const prompt = this.hasInput
            ? this.inputAttrs.value || ''
            : '';

        return {
            prompt,
            isActive: false,
            validationMessage: '',
            isCompositing: false,
            isLoading: false
        }
    },
    computed: {
        // `safeInputAttrs` is a shallow copy of `inputAttrs` except for `value`
        // `value` should not be specified to `v-bind` of the input element
        // because it inhibits `v-model` of the input on Vue 3
        safeInputAttrs() {
            const attrs = { ...this.inputAttrs };
            delete attrs.value;
            if (typeof attrs.required === 'undefined') {
                attrs.required = true;
            }
            return attrs
        },
        dialogClass() {
            return [this.size, {
                'has-custom-container': this.container !== null
            }]
        },
        /**
        * Icon name (MDI) based on the type.
        */
        iconByType() {
            switch (this.type) {
                case 'is-info':
                    return 'information'
                case 'is-success':
                    return 'check-circle'
                case 'is-warning':
                    return 'alert'
                case 'is-danger':
                    return 'alert-circle'
                default:
                    return null
            }
        },
        showCancel() {
            return this.cancelOptions.indexOf('button') >= 0
        }
    },
    methods: {
        /**
        * If it's a prompt Dialog, validate the input.
        * Call the confirmCallback prop (function) and close the Dialog.
        */
        confirm() {
            if (this.$refs.input !== undefined) {
                if (this.isCompositing) return
                if (!this.$refs.input.checkValidity()) {
                    this.validationMessage = this.$refs.input.validationMessage;
                    this.$nextTick(() => this.$refs.input.select());
                    return
                }
            }
            this.$emit('confirm', this.prompt);
            this.confirmCallback(this.prompt, this);
            if (this.closeOnConfirm) this.close();
        },

        /**
        * Close the Dialog.
        */
        close() {
            this.isActive = false;
            this.isLoading = false;
            // Timeout for the animation complete before destroying
            setTimeout(() => {
                removeElement(this.$el);
            }, 150);
        },

        /**
        * Start the Loading.
        */
        startLoading() {
            this.isLoading = true;
        },

        /**
        * Cancel the Loading.
        */
        cancelLoading() {
            this.isLoading = false;
        }
    },
    beforeMount() {
        // Insert the Dialog component in the element container
        if (typeof window !== 'undefined') {
            this.$nextTick(() => {
                const container = document.querySelector(this.container) || document.body;
                container.appendChild(this.$el);
            });
        }
    },
    mounted() {
        this.isActive = true;

        this.$nextTick(() => {
            // Handle which element receives focus
            if (this.hasInput) {
                this.$refs.input.focus();
            } else if (this.focusOn === 'cancel' && this.showCancel) {
                this.$refs.cancelButton.$el.focus();
            } else {
                this.$refs.confirmButton.$el.focus();
            }
        });
    }
};

const _hoisted_1 = ["role", "aria-modal"];
const _hoisted_2 = { class: "modal-card animation-content" };
const _hoisted_3 = {
  key: 0,
  class: "modal-card-head"
};
const _hoisted_4 = { class: "modal-card-title" };
const _hoisted_5 = { class: "media" };
const _hoisted_6 = {
  key: 0,
  class: "media-left"
};
const _hoisted_7 = { class: "media-content" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 0,
  class: "field"
};
const _hoisted_10 = { class: "control" };
const _hoisted_11 = { class: "help is-danger" };
const _hoisted_12 = { class: "modal-card-foot" };

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");
  const _component_b_button = resolveComponent("b-button");
  const _directive_trap_focus = resolveDirective("trap-focus");

  return (openBlock(), createBlock(Transition, { name: _ctx.animation }, {
    default: withCtx(() => [
      ($data.isActive)
        ? withDirectives((openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["dialog modal is-active", $options.dialogClass]),
            role: $props.ariaRole,
            "aria-modal": $props.ariaModal
          }, [
            createElementVNode("div", {
              class: "modal-background",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.cancel('outside')))
            }),
            createElementVNode("div", _hoisted_2, [
              ($props.title)
                ? (openBlock(), createElementBlock("header", _hoisted_3, [
                    createElementVNode("p", _hoisted_4, toDisplayString($props.title), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true),
              createElementVNode("section", {
                class: normalizeClass(["modal-card-body", { 'is-titleless': !$props.title, 'is-flex': $props.hasIcon }])
              }, [
                createElementVNode("div", _hoisted_5, [
                  ($props.hasIcon && ($props.icon || $options.iconByType))
                    ? (openBlock(), createElementBlock("div", _hoisted_6, [
                        createVNode(_component_b_icon, {
                          icon: $props.icon ? $props.icon : $options.iconByType,
                          pack: $props.iconPack,
                          type: $props.type,
                          both: !$props.icon,
                          size: "is-large"
                        }, null, 8 /* PROPS */, ["icon", "pack", "type", "both"])
                      ]))
                    : createCommentVNode("v-if", true),
                  createElementVNode("div", _hoisted_7, [
                    createElementVNode("p", null, [
                      (_ctx.$slots.default)
                        ? renderSlot(_ctx.$slots, "default", { key: 0 })
                        : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
                            createElementVNode("div", { innerHTML: $props.message }, null, 8 /* PROPS */, _hoisted_8)
                          ], 64 /* STABLE_FRAGMENT */))
                    ]),
                    ($props.hasInput)
                      ? (openBlock(), createElementBlock("div", _hoisted_9, [
                          createElementVNode("div", _hoisted_10, [
                            withDirectives(createElementVNode("input", mergeProps({
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.prompt) = $event)),
                              class: ["input", { 'is-danger': $data.validationMessage }],
                              ref: "input"
                            }, $options.safeInputAttrs, {
                              onCompositionstart: _cache[2] || (_cache[2] = $event => ($data.isCompositing = true)),
                              onCompositionend: _cache[3] || (_cache[3] = $event => ($data.isCompositing = false)),
                              onKeydown: _cache[4] || (_cache[4] = withKeys((...args) => ($options.confirm && $options.confirm(...args)), ["enter"]))
                            }), null, 16 /* FULL_PROPS */), [
                              [vModelDynamic, $data.prompt]
                            ])
                          ]),
                          createElementVNode("p", _hoisted_11, toDisplayString($data.validationMessage), 1 /* TEXT */)
                        ]))
                      : createCommentVNode("v-if", true)
                  ])
                ])
              ], 2 /* CLASS */),
              createElementVNode("footer", _hoisted_12, [
                ($options.showCancel)
                  ? (openBlock(), createBlock(_component_b_button, {
                      key: 0,
                      ref: "cancelButton",
                      disabled: $data.isLoading,
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.cancel('button')))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString($props.cancelText), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]))
                  : createCommentVNode("v-if", true),
                createVNode(_component_b_button, {
                  type: $props.type,
                  ref: "confirmButton",
                  loading: $data.isLoading,
                  onClick: $options.confirm
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString($props.confirmText), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["type", "loading", "onClick"])
              ])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_1)), [
            [_directive_trap_focus, $props.trapFocus]
          ])
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]))
}

script.render = render;
script.__file = "src/components/dialog/Dialog.vue";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function open(propsData, app) {
  var slot;
  if (Array.isArray(propsData.message)) {
    slot = propsData.message;
    delete propsData.message;
  }
  function createDialog(_onConfirm, _onCancel) {
    var container = document.createElement('div');
    // Vue 3 requires a new app to mount another component
    var vueInstance = createApp({
      data: function data() {
        return {
          dialogVNode: null
        };
      },
      methods: {
        close: function close() {
          var dialog = getComponentFromVNode(this.dialogVNode);
          if (dialog) {
            dialog.close();
          }
        },
        startLoading: function startLoading() {
          var dialog = getComponentFromVNode(this.dialogVNode);
          if (dialog) {
            dialog.startLoading();
          }
        },
        cancelLoading: function cancelLoading() {
          var dialog = getComponentFromVNode(this.dialogVNode);
          if (dialog) {
            dialog.cancelLoading();
          }
        }
      },
      render: function render() {
        this.dialogVNode = h(script, _objectSpread(_objectSpread({}, propsData), {}, {
          // intentionally overrides propsData.onConfirm
          // to prevent propsData.onConfirm from receiving a "confirm" event
          onConfirm: function onConfirm() {
            if (_onConfirm != null) {
              _onConfirm.apply(void 0, arguments);
            }
          },
          // intentionally override propsData.onCancel
          // to prevent propsData.onCancel from receiving a "cancel" event
          onCancel: function onCancel() {
            if (_onCancel != null) {
              _onCancel.apply(void 0, arguments);
            }
            vueInstance.unmount();
          },
          confirmCallback: function confirmCallback() {
            if (propsData.onConfirm != null) {
              propsData.onConfirm.apply(propsData, arguments);
            }
          },
          cancelCallback: function cancelCallback() {
            if (propsData.onCancel != null) {
              propsData.onCancel.apply(propsData, arguments);
            }
          }
        }), slot ? {
          "default": function _default() {
            return slot;
          }
        } : undefined);
        return this.dialogVNode;
      }
    });
    if (app) {
      copyAppContext(app, vueInstance);
    }
    return vueInstance.mount(container);
  }
  if (!config.defaultProgrammaticPromise) {
    return createDialog();
  } else {
    return new Promise(function (resolve) {
      var dialog = createDialog(function (event) {
        return resolve({
          result: event || true,
          dialog: dialog
        });
      }, function () {
        return resolve({
          result: false,
          dialog: dialog
        });
      });
    });
  }
}
var DialogProgrammatic = /*#__PURE__*/function () {
  function DialogProgrammatic(app) {
    _classCallCheck(this, DialogProgrammatic);
    this.app = app; // may be undefined in the testing environment
  }
  _createClass(DialogProgrammatic, [{
    key: "alert",
    value: function alert(params) {
      if (typeof params === 'string') {
        params = {
          message: params
        };
      }
      var defaultParam = {
        canCancel: false
      };
      var propsData = merge(defaultParam, params);
      return open(propsData, this.app);
    }
  }, {
    key: "confirm",
    value: function confirm(params) {
      var defaultParam = {};
      var propsData = merge(defaultParam, params);
      return open(propsData, this.app);
    }
  }, {
    key: "prompt",
    value: function prompt(params) {
      var defaultParam = {
        hasInput: true
      };
      var propsData = merge(defaultParam, params);
      return open(propsData, this.app);
    }
  }]);
  return DialogProgrammatic;
}();
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponentProgrammatic(Vue, 'dialog', new DialogProgrammatic(Vue));
  }
};

export { script as BDialog, DialogProgrammatic, Plugin as default };
